export const translations = {
  // Navigation
  home: 'الرئيسية',
  products: 'المنتجات',
  categories: 'الفئات',
  cart: 'السلة',
  checkout: 'الدفع',
  login: 'تسجيل الدخول',
  register: 'إنشاء حساب',
  logout: 'تسجيل الخروج',
  profile: 'الملف الشخصي',
  admin: 'لوحة التحكم',

  // Product related
  'add_to_cart': 'أضف للسلة',
  'adding': 'جاري الإضافة...',
  'out_of_stock': 'نفد من المخزن',
  'featured': 'مميز',
  'sale': 'خصم',
  'price': 'السعر',
  'original_price': 'السعر الأصلي',
  'sale_price': 'سعر الخصم',
  'no_image': 'لا توجد صورة',
  'view_details': 'عرض التفاصيل',
  'product_details': 'تفاصيل المنتج',
  'short_description': 'وصف مختصر',
  'description': 'الوصف',
  'specifications': 'المواصفات',
  'quantity': 'الكمية',
  'category': 'الفئة',
  'brand': 'العلامة التجارية',
  'sku': 'رمز المنتج',
  'weight': 'الوزن',
  'dimensions': 'الأبعاد',
  'stock_status': 'حالة المخزن',
  'in_stock': 'متوفر',
  'stock_quantity': 'الكمية المتوفرة',

  // Cart
  'shopping_cart': 'سلة التسوق',
  'cart_empty': 'السلة فارغة',
  'cart_empty_message': 'لم تقم بإضافة أي منتجات بعد',
  'continue_shopping': 'متابعة التسوق',
  'item': 'المنتج',
  'items': 'المنتجات',
  'total': 'المجموع',
  'subtotal': 'المجموع الفرعي',
  'tax': 'الضريبة',
  'shipping': 'الشحن',
  'discount': 'الخصم',
  'grand_total': 'المجموع الإجمالي',
  'update_cart': 'تحديث السلة',
  'remove_item': 'حذف المنتج',
  'proceed_to_checkout': 'متابعة الدفع',

  // Checkout
  'billing_information': 'معلومات الفوترة',
  'shipping_information': 'معلومات الشحن',
  'payment_method': 'طريقة الدفع',
  'order_summary': 'ملخص الطلب',
  'place_order': 'تأكيد الطلب',
  'first_name': 'الاسم الأول',
  'last_name': 'اسم العائلة',
  'email': 'البريد الإلكتروني',
  'phone': 'رقم الهاتف',
  'address': 'العنوان',
  'city': 'المدينة',
  'country': 'الدولة',
  'cash_on_delivery': 'الدفع عند الاستلام',
  'credit_card': 'بطاقة ائتمان',
  'paypal': 'باي بال',

  // Forms
  'required_field': 'حقل مطلوب',
  'invalid_email': 'بريد إلكتروني غير صحيح',
  'password_too_short': 'كلمة المرور قصيرة جداً',
  'passwords_dont_match': 'كلمات المرور غير متطابقة',
  'submit': 'إرسال',
  'cancel': 'إلغاء',
  'save': 'حفظ',
  'edit': 'تعديل',
  'delete': 'حذف',
  'confirm': 'تأكيد',
  'yes': 'نعم',
  'no': 'لا',

  // Messages
  'success': 'نجح',
  'error': 'خطأ',
  'warning': 'تحذير',
  'info': 'معلومات',
  'loading': 'جاري التحميل...',
  'no_results': 'لا توجد نتائج',
  'try_again': 'حاول مرة أخرى',
  'something_went_wrong': 'حدث خطأ ما',

  // Common
  'search': 'البحث',
  'filter': 'تصفية',
  'sort': 'ترتيب',
  'sort_by': 'ترتيب حسب',
  'name_asc': 'الاسم تصاعدي',
  'name_desc': 'الاسم تنازلي',
  'price_asc': 'السعر من الأقل للأعلى',
  'price_desc': 'السعر من الأعلى للأقل',
  'newest': 'الأحدث',
  'oldest': 'الأقدم',
  'featured_first': 'المميزة أولاً',
  'all_categories': 'جميع الفئات',
  'show_all': 'عرض الكل',
  'view_more': 'عرض المزيد',
  'back': 'رجوع',
  'next': 'التالي',
  'previous': 'السابق',
  'close': 'إغلاق',
  'open': 'فتح',

  // Footer
  'about_us': 'من نحن',
  'contact_us': 'اتصل بنا',
  'privacy_policy': 'سياسة الخصوصية',
  'terms_of_service': 'شروط الخدمة',
  'follow_us': 'تابعنا',
  'newsletter': 'النشرة الإخبارية',
  'subscribe': 'اشترك',
  'all_rights_reserved': 'جميع الحقوق محفوظة',

  // Admin
  'dashboard': 'لوحة التحكم',
  'orders': 'الطلبات',
  'customers': 'العملاء',
  'settings': 'الإعدادات',
  'analytics': 'التحليلات',
  'reports': 'التقارير',
  'inventory': 'المخزن',
  'users': 'المستخدمين',

  // Status
  'pending': 'معلق',
  'processing': 'قيد المعالجة',
  'shipped': 'تم الشحن',
  'delivered': 'تم التسليم',
  'cancelled': 'ملغي',
  'refunded': 'تم الاسترداد',
  'completed': 'مكتمل',

  // Invoice
  'invoice': 'فاتورة',
  'order_number': 'رقم الطلب',
  'order_date': 'رقم الطلب',  // Changed from date to order number
  'bill_to': 'إرسال الفاتورة إلى',
  'order_details': 'تفاصيل الطلب',
  'items_ordered': 'المنتجات المطلوبة',
  'unit_price': 'سعر الوحدة',
  'notes': 'ملاحظات',
  'thank_you': 'شكراً لك على ثقتك بنا!',
  'print_invoice': 'طباعة الفاتورة',
  'print': 'طباعة',
  'shipping_address': 'العنوان',  // Changed from shipping address to address
  'contact_info': 'الهاتف',  // Changed from contact info to phone
  'attributes': 'المواصفات',

  // Date & Time
  'today': 'اليوم',
  'yesterday': 'أمس',
  'this_week': 'هذا الأسبوع',
  'last_week': 'الأسبوع الماضي',
  'this_month': 'هذا الشهر',
  'last_month': 'الشهر الماضي',
}

export const t = (key, fallback = key) => {
  return translations[key] || fallback
}

export default translations
